export const template_product_customer = "template_product_customer";
export const template_product_principal= "template_product_principal";
export const template_product_mapping= "template_product_mapping";
export const template_product_mapping_ho= "template_product_mapping_ho";
export const template_customer_store_mapping= "template_customer_store_mapping";
export const template_store= "template_store";
